import {createReducer} from '@reduxjs/toolkit';

import * as surveyActions from 'client/common/store/actions/survey';

import {SurveyStore} from './types';

const initialState: SurveyStore = {};

export default createReducer(initialState, {
    [surveyActions.setSurvey.type]: (state: SurveyStore, action: surveyActions.SetSurveyAction) => {
        return {
            ...state,
            ...action.payload
        };
    }
});
